import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {media} from '../../style/utils'

class Templates extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
  }

  render() {
    const { items } = this.props
    return (
      <ShowSection>
        {items.map((item) =>
          <Link to={`/preview/${item}`} key={item}>
            <strong>{item}</strong>
            <picture>
              <source type="image/webp" srcSet={`${process.env.REACT_APP_API_URL}/screenshots/${item}.webp`} />
              <img src={`${process.env.REACT_APP_API_URL}/screenshots/${item}.jpg`} alt={item} />
            </picture>
          </Link>
        )}
      </ShowSection>
    )
  }
}

const ShowSection = styled.section`
  min-height: calc(100vh - 250px);
  background: brown;
  padding: 40px 20px;
  z-index: 1;
  position: relative;
  &:before/*, &:after*/ {
    content: "";
    display: block;
    position: absolute;
    left:0;
    right:0;
    margin-top: -60px;
    height: 40px;
    background:
      linear-gradient(
        45deg, brown 33.333%,
        transparent 33.333%, transparent 66.667%,
        brown 66.667%
      ),
      linear-gradient(
        -45deg, brown 33.333%,
        transparent 33.333%, transparent 66.667%,
        brown 66.667%
      );
      background-size: 20px 40px;
      background-position: 0 -60px;
  }
  &:after {
    margin-top: 20px;
  }
  a {
    width: calc(20% - 20px);
    display: inline-block;
    margin: 10px 10px 30px;
    border: 5px solid white;
    box-shadow: 5px 5px 5px #222;
    font-size: 0;
    position: relative;
  }
  a:hover, a:focus {
    strong {
      border-color: white;
    }
  }
  ${media.lgOnly`
    a { width: calc(25% - 20px); }
  `};
  ${media.md`
    a { width: calc(33.3% - 20px); }
  `};
  ${media.sm`
    a { width: calc(50% - 20px); }
  `};
  ${media.xs`
    a { width: calc(100% - 20px); }
  `};

  strong {
    font-size: 18px;
    font-variant-ligatures: none;
    letter-spacing: 1px;
    background-color: #222;
    color: white;
    padding: 5px 10px;
    border: 5px solid transparent;
    position: absolute;
    z-index: 1;
    left: 10px;
    top: -25px;
    transition: border-color .3s;
  }

  /*.no-overflow {
    overflow: hidden;
    max-height: 250px;
  }*/

  img {
   width: 100%;
   height: 250px;
   object-fit: cover;
   object-position: top;
   vertical-align: middle;
   filter: brightness(.9);
   transition: filter .2s;
   /*transform: scale(1.1);
   transform-origin: top center;
   transition-duration: .1s;
   transition-property: transform;
   transition-delay: .5s;*/
  }
  a:hover img, a:focus img {
   /*transform: translateY(calc(-100% + 250px));
   transition-duration: 2s;*/
   filter: brightness(1);
  }

  @keyframes sk-rotateplane {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    } 50% {
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    } 100% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }
`
export default Templates



// WEBPACK FOOTER //
// ./src/pages/Welcome/Templates.jsx